module.exports = __webpack_public_path__ + "static/media/node.270f55ff.png";